import { type ReactNode, useEffect } from 'react'
import { useUIStore } from '@/shared/stores/uiStore'

interface AccessibilityProviderProps {
  readonly children: ReactNode
}

const FONT_SIZE_MAP = {
  small: '14px',
  normal: '16px',
  large: '18px',
  xlarge: '20px',
} as const

export function AccessibilityProvider({ children }: AccessibilityProviderProps) {
  const { fontSize, reducedMotion, highContrast, focusIndicator } = useUIStore()

  useEffect(() => {
    const root = window.document.documentElement
    root.style.fontSize = FONT_SIZE_MAP[fontSize]
  }, [fontSize])

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.toggle('reduced-motion', reducedMotion)
  }, [reducedMotion])

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.toggle('high-contrast', highContrast)
  }, [highContrast])

  useEffect(() => {
    const root = window.document.documentElement
    root.classList.toggle('focus-indicator', focusIndicator)
  }, [focusIndicator])

  return <>{children}</>
}

export default AccessibilityProvider